import {ArchiveRecord} from 'archive/ArchiveConstants';
import {LookupConfigSpec} from 'lookup-config/LookupConfigModalConstants';
import {SchemaField, SnapshotField} from 'schemas/fields/SchemaFieldConstants';
import * as net from 'util/Net';

interface CreateAndUpdateSnapshotFieldResponse {
  snapshotField: SnapshotField;
}

interface BaseSnapshotFieldRequestParams {
  displayName?: string;
  systemName?: string;
  tooltipText?: string | null;
  lookupConfigSpec: LookupConfigSpec;
}

interface CreateSnapshotFieldParams extends BaseSnapshotFieldRequestParams {
  schemaId: string;
}

export function createSnapshotField({
  schemaId,
  displayName,
  systemName,
  tooltipText,
  lookupConfigSpec,
}: CreateSnapshotFieldParams): Promise<CreateAndUpdateSnapshotFieldResponse> {
  return net.postJSONPromise({
    url: '/1/api/snapshot-field',
    data: {
      schemaId,
      displayName,
      systemName,
      tooltipText,
      lookupConfigSpec,
    },
  });
}

interface UpdateSnapshotFieldParams extends Partial<BaseSnapshotFieldRequestParams> {
  snapshotFieldId: string;
  archiveRecord: ArchiveRecord | null;
}

export function updateSnapshotField({
  snapshotFieldId,
  displayName,
  systemName,
  tooltipText,
  lookupConfigSpec,
  archiveRecord,
}: UpdateSnapshotFieldParams): Promise<CreateAndUpdateSnapshotFieldResponse> {
  return net.patchJSONPromise({
    url: `/1/api/snapshot-field/${snapshotFieldId}`,
    data: {
      displayName,
      systemName,
      tooltipText,
      lookupConfigSpec,
      archiveRecord,
    },
  });
}

interface ConvertSnapshotFieldParams {
  snapshotFieldId: string;
}

export interface ConvertSnapshotFieldResponse {
  schemaField: SchemaField;
}

export function convertSnapshotField({
  snapshotFieldId,
}: ConvertSnapshotFieldParams): Promise<ConvertSnapshotFieldResponse> {
  return net.postPromise({
    url: `/1/api/snapshot-field/${snapshotFieldId}:unsnapshot`,
  });
}
